import React ,{useContext} from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from '../../context/userContext'; // Import your hook

const ProtectedRoute = ({ children, redirectPath = "/login" }) => {
  const { user,loading } = useContext(UserContext);
  const location = useLocation(); // Get the current URL
  console.log('ProtectedRoute - user:', user);

  if (loading) {
    return null; // Don't render anything while checking auth status
  }

  if (!user) {
    // If not logged in, redirect to login page
    // We pass the current location in `state`
    // so the login page can redirect back after success.
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

 
  return children;
};

export default ProtectedRoute;